export const AmplitudeEvent = {
	TEMPLATE_SELECTED: 'bcct_templateselected',
	TIMER_CREATED: 'bcct_timercreated',
} as const;
